var _use, _use2, _use3, _use4, _use5, _use6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2800 1400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 2800,
    height: 1400,
    id: "red",
    style: {
      fill: "#cc0001"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2800,
    height: 100,
    y: 1300,
    id: "white",
    style: {
      fill: "#fff"
    }
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    transform: "translate(0,-200)",
    id: "use3035",
    xlinkHref: "#white"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(0,-400)",
    id: "use3038",
    xlinkHref: "#white"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(0,-600)",
    id: "use3062",
    xlinkHref: "#white"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(0,-800)",
    id: "use3064",
    xlinkHref: "#white"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(0,-1000)",
    id: "use3066",
    xlinkHref: "#white"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(0,-1200)",
    id: "use3068",
    xlinkHref: "#white"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 1400,
    height: 800,
    id: "blue",
    style: {
      fill: "#010066"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 576,100 C 409.85356,100 275,234.40553 275,400 C 275,565.59446 409.85356,699.99999 576,700 C 636.02725,700 691.95466,682.43566 738.92693,652.21675 C 711.57383,661.65623 682.2175,666.81914 651.65599,666.81914 C 504.3291,666.81915 384.75944,547.64674 384.75944,400.80929 C 384.75944,253.97184 504.32908,134.79944 651.65599,134.79944 C 684.21403,134.79944 715.40185,140.61419 744.2578,151.26671 C 696.21698,118.90999 638.30493,100 576,100 z",
    id: "path4945",
    style: {
      fill: "#fc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 914.28574,471.42858 L 814.74817,418.17806 L 844.17832,527.16068 L 777.60261,435.99589 L 756.83247,546.9551 L 736.40474,435.93234 L 669.5481,526.89131 L 699.31432,418.00001 L 599.61295,470.94319 L 673.67755,385.75059 L 560.87853,390.19195 L 664.57212,345.5715 L 561.01668,300.63137 L 673.80146,305.42069 L 600.00003,220.00001 L 699.53759,273.25053 L 670.10745,164.26791 L 736.68316,255.4327 L 757.4533,144.47349 L 777.88103,255.49624 L 844.73767,164.53728 L 814.97145,273.42858 L 914.67282,220.4854 L 840.60822,305.67799 L 953.40723,301.23664 L 849.71365,345.85709 L 953.26909,390.79722 L 840.48431,386.0079 z",
    transform: "matrix(1.2737922,0,0,1.2422928,-89.4427,-29.478379)",
    id: "path4959",
    style: {
      fill: "#fc0"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMy);
export default __webpack_public_path__ + "static/media/my.05adc6befa4fb588ee6cdf98aff2338f.svg";
export { ForwardRef as ReactComponent };